module.exports = __webpack_public_path__ + "img/header-weddingRingsBestseller.f1f26fc.webp";